import { defineStore } from 'pinia';
import type { UserPermissions, UserRole } from '../common/enums/user-role-permissions';

interface UserRolePermissionsState {
  role: UserRole | undefined;
  permissions: UserPermissions;
}

const defaultPermissions: UserPermissions = {
  CAN_REMOVE_ADMINS: false,
  CAN_ADD_ADMINS: false,
  CAN_ADD_REMOVE_USERS: false,
  TEAMS_PAGE: false,
  PENDING_PAYMENTS_PAGE: false,
  TRANSACTION_HISTORY_PAGE: false,
  BANKS_PAGE: false,
  PREFERENCES_PAGE: false,
  SEND_PAYMENTS_PAGE: false,
  WALLETS_PAGE: false,
  CATALOGS_PAGE: false,
  INVOICES_PAGE: false,
  SIGNTAURES_PAGE: false,
  AI_ASSISTANT_PAGE: false,
  BRANDING_PROFILES: false,
};

export const useUserRolePermissionsStore = defineStore('userRolePermissionsStore', {
  state: (): UserRolePermissionsState => ({
    role: undefined,
    permissions: { ...defaultPermissions },
  }),
  actions: {
    updateRoles(role: UserRole) {
      this.role = {
        ...this.role,
        ...role,
      };
    },
    async fetchPermissions(app: string) {
      const roleId = Number(this.role?.id);
      try {
        const { $snapApi } = useNuxtApp();
        const payload = { roleId, app };
        const response = await $snapApi({
          method: 'post',
          url: 'iam/get-role-permissions',
          data: payload,
          headers: { 'Content-Type': 'application/json' },
        });
        if (response.status == 200) {
          const updatedPermissions = { ...defaultPermissions };
          for (const key of response.data as Array<keyof UserPermissions>) {
            if (key in updatedPermissions) {
              updatedPermissions[key] = true;
            }
          }
          this.permissions = updatedPermissions;
        }
      } catch (err) {
        console.error('Failed to load permissions');
      } finally {
        // TODO: ???? WRONG
        // navigateTo('/');
      }
    },
  },
});
